import { useEffect, useState } from 'react';
import { Info } from 'lucide-react';
import toast from 'react-hot-toast';
import { authFetch } from '../../services/api';

export default function SharingSettingsPanel() {
  const [prefs, setPrefs] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    authFetch('/api/sharing/me')
      .then((r) => (r.ok ? r.json() : null))
      .then(setPrefs);
  }, []);

  const update = async (patch) => {
    setSaving(true);
    try {
      const res = await authFetch('/api/sharing/me', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...prefs, ...patch }),
      });
      if (!res.ok) throw new Error('Save failed');
      const next = await res.json();
      setPrefs(next);
      toast.success('Sharing preferences updated');
    } catch (err) {
      toast.error(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (!prefs) return null;

  return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl p-5 space-y-4">
      <div>
        <h3 className="text-white font-medium mb-1">Share with the broker</h3>
        <div className="flex items-start gap-2 mt-3 text-sm text-slate-400 bg-slate-800/40 border border-slate-800 rounded-lg px-3 py-2.5">
          <Info size={16} className="text-emerald-400 mt-0.5 flex-shrink-0" />
          <p>
            Before enabling these, the broker should have contacted you to discuss
            your portfolio. They'll act as your broker throughout the process.
            Enabling either toggle gives them read-only access to the data you
            select; you can switch them off again at any time.
          </p>
        </div>
      </div>

      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={prefs.share_portfolio_with_brokers}
          disabled={saving}
          onChange={(e) => update({ share_portfolio_with_brokers: e.target.checked })}
          className="mt-1 accent-emerald-500 w-5 h-5"
        />
        <span>
          <span className="text-white text-sm font-medium">Share my portfolio</span>
          <span className="block text-xs text-slate-500 mt-0.5">
            Addresses, valuations, outstanding debt, LTV, attached property documents.
          </span>
        </span>
      </label>

      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={prefs.share_personal_docs_with_brokers}
          disabled={saving}
          onChange={(e) => update({ share_personal_docs_with_brokers: e.target.checked })}
          className="mt-1 accent-emerald-500 w-5 h-5"
        />
        <span>
          <span className="text-white text-sm font-medium">Share my identity vault</span>
          <span className="block text-xs text-slate-500 mt-0.5">
            Proof of ID, proof of address, bank statements, and (if you provide them)
            limited-company filings.
          </span>
        </span>
      </label>
    </div>
  );
}
